<template>
  <div class="dialog wrong-book-dialog">
    <div class="content">
      <div class="close" @click="onClose"></div>
      <div class="title">错题本</div>
      <div class="main">
        <div class="nav">
          <div class="select-wrapper">
            <el-select
              popper-class="select-down"
              v-model="wrongType"
              @change="changeWrongType">
              <el-option
                label="当前错题"
                value="current"
              >
              </el-option>
              <el-option
                label="历史错题"
                value="history"
              >
              </el-option>
            </el-select>
            <template>
              <span class="select-title">学科：</span>
              <el-select
                popper-class="select-down"
                v-model="currentProject"
                @change="selectCourse">
                <el-option
                  v-for="item in projectList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </template>
            <template>
              <span class="select-title">课程类型：</span>
              <el-select
                popper-class="select-down"
                v-model="currentCourseType"
                @change="selectCourseType">
                <el-option
                  v-for="item in courseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </template>
            <template>
              <span class="select-title">课程：</span>
              <el-input
                class="search-input"
                v-model="courseName"
                @keyup.native.enter="onSearchCourseName"
                placeholder="请输入课程名称">
                <el-button
                  class="btn btn-primary"
                  @click="onSearchCourseName"
                  slot="append"
                  icon="el-icon-search"></el-button>
              </el-input>
            </template>
          </div>
        </div>
        <div class="wrong-list">
          <template v-if="wrongBookList.length">
            <div
              class="wrong-list-item"
              v-for="item in wrongBookList"
              :key="item.id">
              <div class="item-describe">
                <span>{{item.name}}</span>
                <span>|</span>
                <span>
                  共{{item.wrongCount}}个易错{{item.projectCode === 'EnglishWord' ? '词' : '题'}}
                </span>
              </div>
              <div class="item-control">
                <div
                  @click="start(item)"
                  class="btn btn-orange-square">开始练习</div>
                <div
                  v-if="isShowCheckButton"
                  class="btn btn-blue-square"
                  @click="checkWrongWord(item)">查看易错词</div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="no-wrong">
              <span>暂无练习内容，先去学习吧！</span>
            </div>
          </template>
        </div>
        <div class="pagination-wrapper">
          <el-pagination
            layout="prev, pager, next"
            :total="total"
            :page-size="5"
            @current-change="onPageChange" />
        </div>
      </div>
    </div>
    <van-dialog
      class="wrong-word-dialog"
      ref="wrong-word"
      :modal="false">
      <span slot="title">查看易错词</span>
      <div class="wrong-word-content">
        <div class="word-describe">
          <span>{{currentCourse.name}}</span>
          共{{currentCourse.wrongCount}}个易错词
        </div>
        <div class="wrong-word-list">
          <div
            v-for="(item, index) in currentCourse.wordList"
            :key="`${item}-${index}`"
            class="wrong-word-item">
            <div class="word">{{item.word}}</div>
            <div class="explain">{{item.explain}}</div>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { Select, Option, Input, Pagination, Button } from 'element-ui';
import VanDialog from '@/components/common/Dialog.vue';
import api from '@/api/graphql/course';
import server from '@/api/course';
import utils from '@/services/utils';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElPagination: Pagination,
    ElButton: Button,
    VanDialog,
  },
  data() {
    return {
      projectList: [],
      courseTypeList: [],
      courseName: '',
      wrongType: 'current',
      currentProject: '',
      currentCourseType: '',
      wrongBookList: [],
      currentCourse: {},
      total: 0,
    };
  },
  watch: {
    currentProject() {
      this.currentCourseType = '';
    },
    show() {
      if (this.show) {
        this.fetchCourseList();
      }
    },
  },
  computed: {
    isShowCheckButton() {
      const item = utils.Array.find(this.courseTypeList, { code: this.currentCourseType }, 'code');
      if (item) {
        return item.template_code === 'EnglishWord';
      }
      return true;
    },
  },
  methods: {
    onClose() {
      this.$emit('close', {
        scene: 'index',
      });
    },
    changeWrongType() {
      this.fetchCourseList();
    },
    start(item) {
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          course: {
            ...item,
            id: item.courseId,
            type: item.code,
          },
          ...item,
          type: item.code === 'BDC' ? 'bdc_wrong' : 'wrong',
          mode: this.wrongType,
        }
      })
    },
    fetchCourseList() {
      server.getWrongBookCourses()
        .then(res => {
          this.projectList = res;
          if (!this.currentProject) {
            this.currentProject = this.projectList.length ? this.projectList[0].code : '';
          }
          this.getSubjectList(this.currentProject);
        })
    },
    selectCourse(value) {
      this.getSubjectList(value)
    },
    selectCourseType() {
      this.getWrongBookList();
    },
    getSubjectList(project_code) {
      server.getSubjectList({
        project_code,
      }).then((data) => {
        this.courseTypeList = data;
        if (!this.currentCourseType) {
          this.currentCourseType = this.courseTypeList.length ? this.courseTypeList[0].code : '';
        }
        if (this.currentCourseType && this.currentProject) {
          this.getWrongBookList();
        }
      });
    },
    onPageChange(page) {
      this.getWrongBookList({
        page,
      })
    },
    getWrongBookList({ page = 1 } = {}) {
      if (!this.currentProject) {
        utils.error('请选择学科');
        return;
      }
      if (!this.currentCourseType) {
        utils.error('请选择课程类型');
        return;
      }
      api.getWrongBookList({
        page,
        size: 5,
        type: this.wrongType,
        code: this.currentCourseType,
        name: this.courseName,
      }).then(({ wrongBookList }) => {
        this.total = wrongBookList.total;
        this.wrongBookList = wrongBookList.list;
      });
    },
    onSearchCourseName() {
      this.getWrongBookList();
    },
    checkWrongWord(course) {
      this.currentCourse = course;
      this.$refs['wrong-word'].open();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common/dialog.scss";
@import "@/styles/variables.scss";
.wrong-book-dialog {
  width: 70vw;
  .content {
    display: flex;
    flex-direction: column;
    .title {
      padding: 2vh 2.4vh;
      font-size: 2.4vh;
    }
    .main {
      flex: 1;
      padding: 2vh 2vh 0;
      background: #fff;
      border-radius: 24px;
      overflow: hidden;
      .nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1vh 1vh 1vh 2vh;
        .select-wrapper {
          .select-title {
            margin-left: 4vh;
            color: $primary;
            font-weight: 700;
          }
          /deep/ .el-select {
            width: 150px;
            .is-focus {
              .el-input__inner {
                border-color: $primary;
              }
            }
            .el-input {
              .el-input__inner {
                &:focus {
                  border-color: $primary;
                }
                color: $primary;
                font-weight: 700;
                border-radius: 24px;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-select__caret {
                    font-size: 2vh;
                    font-weight: 700;
                    color: $primary;
                  }
                }
              }
            }
          }
          /deep/ .search-input {
            width: 200px;
            .el-input-group__append {
              text-align: center;
              background: $primary;
              border-width: 1px 0;
              border-color: $primary;
              &:hover {
                filter: brightness(108%);
              }
              .el-button {
                .el-icon-search {
                  color: #fff;
                }
              }
            }
            .is-active, .el-input__inner:focus {
              border-color: $primary;
            }
          }
        }
      }
      .wrong-list {
        min-height: 63vh;
        .no-wrong {
          height: 63vh;
          display: flex;
          align-items: center;
          justify-content: center;
          color: $primary;
          font-size: 3vh;
          font-weight: 700;
        }
        .wrong-list-item {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          margin: 2vh 0;
          padding: 0 20px;
          width: 100%;
          height: 11vh;
          border: 1px solid $primary;
          border-radius: 15px;
          .item-describe {
            width: 50%;
            color: $primary;
            font-size: 2vh;
            font-weight: 700;
            span {
              display: inline-block;
              margin-left: 10px;
            }
          }
          .item-control {
            display: flex;
            justify-content: flex-end;
            width: 50%;
            .btn {
              margin: 0 10px;
            }
          }
        }
      }
      .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin: 10px 0;
        /deep/ .el-pagination {
          .el-pager {
            .active {
              color: $primary;
            }
            button:hover {
              color: $primary;
            }
            .number:hover {
              color: $primary;
            }
          }
        }
      }
    }
  }
  .wrong-word-dialog {
    /deep/ .el-dialog {
      width: 66vw!important;
      border-radius: 24px;
      overflow: hidden;
      .dialog-title {
        font-size: 2.4vh;
      }
      .el-dialog__body {
        .content {
          padding: 20px 20px;
        }
      }
    }
    .wrong-word-content {
      height: 60vh;
      overflow-y: auto;
      .word-describe {
        margin: 0 2vh 20px;
        font-size: 2.4vh;
        span {
          color: $primary;
          font-weight: 700;
        }
      }
      .wrong-word-list {
        .wrong-word-item {
          padding: 2vh;
          display: flex;
          font-size: 2.2vh;
          border-radius: 28px;
          .word {
            width: 20%;
            font-weight: 700;
          }
          .explain {
            width: 80%;
          }
        }
        .wrong-word-item:nth-child(odd) {
          background: #dadbfa;
        }
      }
    }
  }
}
.select-down {
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-scrollbar__view {
        .selected {
          color: $primary;
        }
      }
    }
  }
}
</style>
